"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commaSeparator = commaSeparator;
exports.formatNumber = formatNumber;
exports.toToman = toToman;
exports.formatPrice = formatPrice;
exports.taskStatusToPersian = taskStatusToPersian;
exports.taskStatusToColor = taskStatusToColor;
exports.taskStatusToBackgroundColor = taskStatusToBackgroundColor;
exports.TaskStatusEnum = void 0;

// export { formatNumber, formatPrice, commaSeparator };
// Number fomatter
function commaSeparator(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
} // A helper for converting non-persian numbers to persian ones.


let arabicNumbers = ["١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"],
    persianNumbers = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"],
    englishNumbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

function searchAndReplaceInNumbers(value, source, target) {
  for (let i = 0, len = target.length; i < len; i++) {
    value = value.replace(new RegExp(source[i], "g"), target[i]);
  }

  return value;
}

function formatNumber(value, to = "fa") {
  value = typeof value === "number" ? String(value) : value;
  if (!value) return value;
  let output = value;

  if (to === "fa") {
    output = searchAndReplaceInNumbers(output, englishNumbers, persianNumbers);
    output = searchAndReplaceInNumbers(output, arabicNumbers, persianNumbers);
  } else if (to === "en") {
    output = searchAndReplaceInNumbers(output, persianNumbers, englishNumbers);
    output = searchAndReplaceInNumbers(output, arabicNumbers, englishNumbers);
  }

  return output;
}

function toToman(val) {
  return val ? Math.trunc(Number(val) / 10) : 0;
}

function formatPrice(val, toman = true) {
  // @ts-ignore
  const convertedToman = toman ? toToman(val) : val;
  return formatNumber(commaSeparator(String(convertedToman)), "fa");
}

let TaskStatusEnum;
exports.TaskStatusEnum = TaskStatusEnum;

(function (TaskStatusEnum) {
  TaskStatusEnum["unassigned"] = "unassigned";
  TaskStatusEnum["assigned"] = "assigned";
  TaskStatusEnum["loaded"] = "loaded";
  TaskStatusEnum["not_present"] = "not_present";
  TaskStatusEnum["done"] = "done";
  TaskStatusEnum["canceled"] = "canceled";
})(TaskStatusEnum || (exports.TaskStatusEnum = TaskStatusEnum = {}));

function taskStatusToPersian(taskStatus) {
  switch (taskStatus) {
    case TaskStatusEnum.assigned:
      return "اختصاص داده شده";

    case TaskStatusEnum.canceled:
      return "کنسل شده";

    case TaskStatusEnum.done:
      return "انجام شده";

    case TaskStatusEnum.loaded:
      return "بارگیری شده";

    case TaskStatusEnum.not_present: // @ts-ignore

    case "not-present":
      return "عدم حضور مشتری";

    case TaskStatusEnum.unassigned:
      return "راننده اختصاص داده نشده";

    default:
      return "نامشخص";
  }
}

function taskStatusToColor(taskStatus) {
  switch (taskStatus) {
    case TaskStatusEnum.assigned:
      return "green.dark920";

    case TaskStatusEnum.canceled:
      return "text.light950";

    case TaskStatusEnum.done:
      return "green.main";

    case TaskStatusEnum.loaded:
      return "green.dark920";

    case TaskStatusEnum.not_present: // @ts-ignore

    case "not-present":
      return "red.dark";

    case TaskStatusEnum.unassigned:
      return "text.midlight";

    default:
      return "common.black";
  }
}

function taskStatusToBackgroundColor(taskStatus) {
  switch (taskStatus) {
    case TaskStatusEnum.assigned:
      return "primary.light940";

    case TaskStatusEnum.canceled:
      return "gray.bg";

    case TaskStatusEnum.done:
      return "green.light500";

    case TaskStatusEnum.loaded:
      return "primary.light940";

    case TaskStatusEnum.not_present: // @ts-ignore

    case "not-present":
      return "red.light";

    case TaskStatusEnum.unassigned:
      return "gray.bg";

    default:
      return "neutrals.100";
  }
}